import { of, EMPTY } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AirAppRoutes } from '../lib/air-api-constant';
import { EConfig } from '../lib/model/common';
import { CommonService, AuthService, StorageService } from '../service';
import { UserControlService } from '../service/userControl/user-control.service';
@Injectable()
export class AirUserSettingsResolver implements Resolve<any> {
    userDetails: any = {};
    constructor(
        private userControlService: UserControlService,
        private router: Router,
        private commonService: CommonService,
        private authService: AuthService,
        private storageService:StorageService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.userControlService.getAirUserConfig().then((details: any) => {
            if (details && details.companies.length > 0) {
                this.userControlService.updateUserSettings(details);
                this.authService.updateEula(details.eula.isEulaAccepted, details.companies);
                this.storageService.setItem("keyReference",details.keyReference.keyReference);//Author --- Kalindi 
                return of(details);
            } else {
                this.commonService.navigateRoute({
                    route: AirAppRoutes.User.NOT_ASSOCIATED,
                    type: 'User'
                });
                return EMPTY;
            }
        }, (err: any) => {

            return EMPTY;
        });
    }
}